<template>
    <v-dialog
        v-model="showDialog"
        width="600"
    >
        <v-card v-if="data">
            <v-card-title style="background-color: #009688; color: white; word-wrap: normal;">
                Do you really want to remove this from the group?
            </v-card-title>
            <v-card-text style="max-height: 70vh; overflow-y: scroll; background-color: #EDFFFB;">
                <v-simple-table
                    dense
                    style="background-color: white; border-radius: 20px; padding: 10px 10px 0  10px; margin-top: 25px"
                >
                    <template #default>
                        <tbody>
                            <tr>
                                <td class="text-left">
                                    MSU Group ID
                                </td>
                                <td>{{ data.MSUGRP_ID }}</td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    MSU Group Name
                                </td>
                                <td>{{ data.info.group.MSUGRP_NAME }}</td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    MSU Code
                                </td>
                                <td>{{ data.MSU_C }}</td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    Hospital/Clinic Name
                                </td>
                                <td>{{ data.info.msu.hosp_name }}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>
            <v-card-actions style="background-color: #EDFFFB;">
                <v-spacer />
                <v-btn
                    outlined
                    class="white--text"
                    color="teal darken-1"
                    style="text-transform: none; width: 105px;"
                    @click="showDialog = false"
                >
                    CLOSE
                </v-btn>
                <v-btn
                    color="teal darken-1 white--text"
                    class="white--text"
                    style="text-transform: none; width: 105px; font-weight: 600"
                    :loading="loading"
                    @click="handleDeleteMsuToGroup"
                >
                    REMOVE
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { moment } from '../../../../../../utils/date-shim'
export default {
    props: ['show', 'data', 'notif'],
    data: ()=>({
        loading: false
    }),
    computed: {
        ...mapGetters(['deleteMsuFromGroupData']),
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        async deleteMsuFromGroupData(newVal) {
            if (newVal) {
                if (newVal.status === 200) {
                    this.notif.type = 'success'
                    this.notif.color = 'success'
                    this.notif.timeout = 5000
                    this.notif.msg = 'MSU has been deleted from the group.'
                    this.notif.show = true
                    this.showDialog = false
                    await this.viewMsuGroup({ ID: this.data.MSUGRP_ID })
                    this.listMsuGroups()
                } else {
                    this.notif.type = 'error'
                    this.notif.color = 'error'
                    this.notif.timeout = 5000
                    this.notif.msg = newVal.state
                    this.notif.show = true
                }
            }
            this.loading = false
        }
    },
    methods: {
        ...mapActions(['deleteMsuFromGroup', 'viewMsuGroup', 'listMsuGroups']),
        handleDeleteMsuToGroup() {
            this.loading = true
            this.deleteMsuFromGroup({ MSUGRP_ID: this.data.MSUGRP_ID, MSU_C: this.data.MSU_C })
        },
        formatDate(date) {
            return moment(date).utcOffset('+0800').format('MMMM DD, YYYY hh:mm A')
        }
    }
}
</script>
